import {
  Labeled,
  minValue,
  NumberInput,
  ReferenceInput,
  required,
  TextField,
  useRecordContext,
} from "react-admin";
import { Grid } from "@mui/material";
import { dormitoryRequests } from "api/dormitoryApi";
import { DormitoryRoomExpositionChoices } from "utils/choices";
import DormitoryAutocompleteInput from "../Partials/DormitoryAutocompleteInput";

const SaveForm = ({ conditionControl }) => {
  const record = useRecordContext();

  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        xs={12}
        md={6}
      >
        <NumberInput
          source="roomNumber"
          label="Номер"
          fullWidth
          validate={[required(), minValue(1)]}
          onWheel={e => e.target.blur()}
        />
      </Grid>

      <Grid
        item
        xs={12}
        md={6}
      >
        <NumberInput
          source="floor"
          label="Етаж"
          fullWidth
          validate={[required(), minValue(1)]}
          onWheel={e => e.target.blur()}
        />
      </Grid>

      <Grid
        item
        xs={12}
        md={6}
      >
        <ReferenceInput
          reference={dormitoryRequests.getBuildingsSelect()}
          source="buildingId"
        >
          <DormitoryAutocompleteInput
            label="Блок"
            fullWidth
            validate={[required()]}
            optionText="name"
          />
        </ReferenceInput>
      </Grid>

      <Grid
        item
        xs={12}
        md={6}
      >
        <ReferenceInput
          reference={dormitoryRequests.getRoomTypesSelect()}
          source="typeId"
        >
          <DormitoryAutocompleteInput
            label="Тип стая"
            fullWidth
            validate={[required()]}
            optionText="name"
          />
        </ReferenceInput>
      </Grid>

      {record?.id ? (
        <Grid
          item
          xs={12}
          md={6}
        >
          {conditionControl || (
            <Labeled label="Състояние">
              <TextField source="conditionDescription" emptyText="—" />
            </Labeled>
          )}
        </Grid>
      ) : null}

      <Grid
        item
        xs={12}
        md={6}
      >
        <DormitoryAutocompleteInput
          source="exposition"
          label="Изложение"
          choices={DormitoryRoomExpositionChoices}
          fullWidth
          validate={[required()]}
        />
      </Grid>
    </Grid>
  );
};

export default SaveForm;
